import { FirebaseOptions } from '@firebase/app';

// Swapped for firebase-config.peech-dev.ts by the peech-dev build configuration.

export const firebaseConfig: FirebaseOptions = {
  apiKey: 'AIzaSyD5ClyeP0iWEm_IPanMVULE6YFkjOYehek',
  authDomain: 'app.getpeech.com',
  // Required by Firestore (credits mirror); same project as the mobile apps.
  projectId: 'voiceservice-217021',
  // The bucket iOS uploads item files to — the gs:// host the backend is given.
  storageBucket: 'voiceservice-217021.appspot.com',
};

// Peech user data lives in a NAMED Firestore database, not the project default (whose rules
// deny everything) — same value the iOS app hardcodes in FirestoreManager.swift.
// All document ids under it are lowercased Peech uuids (not Firebase uids).
export const PEECH_FIRESTORE_DATABASE_ID = 'prod-peech-items';
